import authApi from './authApi';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000';

async function parseJson(res) {
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(data.message || res.statusText || 'Request failed');
    err.response = { data, status: res.status };
    throw err;
  }
  return data;
}

export const adminDocsService = {
  async list() {
    const res = await fetch(`${API_BASE}/api/admin/docs`, {
      headers: authApi.createAuthHeaders()
    });
    return parseJson(res);
  },

  async get(slug) {
    const res = await fetch(`${API_BASE}/api/admin/docs/${encodeURIComponent(slug)}`, {
      headers: authApi.createAuthHeaders()
    });
    return parseJson(res);
  }
};
